import { render } from "./ListMessagePartner.vue?vue&type=template&id=360e8b2d&scoped=true"
import script from "./ListMessagePartner.vue?vue&type=script&lang=js"
export * from "./ListMessagePartner.vue?vue&type=script&lang=js"

import "./ListMessagePartner.vue?vue&type=style&index=0&id=360e8b2d&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360e8b2d"]])

export default __exports__